export default __webpack_public_path__ + "static/media/Lot.d4a484b2.csv";